import React, {Component, Fragment}  from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { loadSettings } from './redux/settings/actions';

import { connect } from 'react-redux'




import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import Login from './containers/Login/Login';
import Signup from './containers/Signup/Signup';
import PrivateApp from './containers/PrivateApp/PrivateApp';

import ProtectedRoute from './hoc/ProtectedRoute';

import moment from 'moment';

moment.updateLocale('en', {
  relativeTime : {
      future: "in %s",
      past:   "%s ago",
      s  : 'a few seconds',
      ss : '%d seconds',
      m:  "1 minute",
      mm: "%d minutes",
      h:  "1 hour",
      hh: "%d hours",
      d:  "1 day",
      dd: "%d days",
      M:  "1 month",
      MM: "%d months",
      y:  "1 year",
      yy: "%d years"
  }
});

class AppRoutes extends Component {
  _isMounted = false;

    componentDidMount(){
      this._isMounted = true;
      this.props.loadSettings();
  }

  componentWillUnmount() {
      this._isMounted = false;
    }
  
    
  render() {
    if(!this.props.termes.termes){
      return null;
    } 

    return ( 
      <Fragment>
        <ToastContainer position={ toast.POSITION.BOTTOM_CENTER } />
        <Router basename="/application">
        
        

      
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/signup" component={Signup} />
            <ProtectedRoute path="/*" isAuth={this.props.token} component={PrivateApp} />
          </Switch>

        </Router>
      </Fragment>

    );
  }
}

const mapStateToProps = (state)=>{
  return {
    token: state.auth.token,
    userinfos: state.auth.userinfos,
    termes: state.settings.termes
  }
};


export default connect(mapStateToProps, {loadSettings})(AppRoutes);
